<template>
    <v-card 
        class="mx-auto mb-12 custom-radius pa-4 pa-lg-6 d-flex flex-column justify-space-between"
        height="100%"
    >
        <div class="d-flex flex-column">
            <div class="title mb-2 mb-lg-4" v-text="project.title"></div>
            <div class="body-1 mb-2 mb-lg-4" v-html="project.shortDescription"></div>            
        </div>
        <div class="text-center">
            <div class="mb-4">
                <div class="c-chip mb-4">
                    <span v-text="`${$t('Topic')}: `"></span> 
                    <span v-text="topic"></span>
                </div>
                <template v-if="project.bidAvaliable">
                    <div class="c-chip mb-4">
                        <span v-text="`${$t('BidingEndsBy')}: `"></span> 
                        <span v-text="bidingDeadline"></span>
                    </div>
                </template>
                <template v-else-if="project.votingDeadline">
                    <div class="c-chip mb-4">
                        <span v-text="`${$t('VotingEndsBy')}: `"></span> 
                        <span v-text="votingDeadline"></span>
                    </div>
                </template>
            </div>
            <template v-if="project.bidAvaliable">
                <v-btn
                    depressed
                    rounded
                    color="primary"
                    class="mt-3"
                    :to="`/${$i18n.locale}/ecreative/bid/${project.id}`"
                    :disabled="!project.canUserBid"
                    v-text="$t('BidNow')"
                ></v-btn>
            </template>
            <template v-else-if="project.rateAvaliable">
                <v-btn
                    depressed
                    rounded
                    color="primary"
                    class="mt-3"
                    :to="`/${$i18n.locale}/ecreative/project/${project.id}/bids/rate`"
                    v-text="$t('ViewAndRateBids')"
                ></v-btn>
            </template>
            <template v-else>
                <div class="title primary--text mt-8" v-text="$t('BidsUnderReview')"></div>
            </template>
        </div>
    </v-card>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'projectCard',
        props: {
            project: {
                type: Object,
                default: () => ({
                    id: 0,
                    title: '',
                    description: '',
                    bidingDeadline: null,
                    votingDeadline: null,
                    canUserBid: false,
                    bidAvaliable: false,
                    rateAvaliable: false,
                })
            },
            topic: {
                type: String,
                default: ''
            }
        },
        computed: {
            bidingDeadline() {
                return moment(this.project.bidDeadline).format('MM/DD/YYYY')
            },
            votingDeadline() {
                return moment(this.project.votingDeadline).format('MM/DD/YYYY')
            }
        }
    }
</script>

<style lang="scss" scoped>
.c-chip{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    border-radius: 16px;
    border: 1px solid $primary;
    color: $primary;
    font-size: 14px;
    line-height: 20px;
}
</style>